import axios from "../../../axios";

const importData = async (resource, rows, headers) => {
  try {
    const { data } = await axios.post("/import_data", { resource, rows, headers });
    return data;
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export {
  importData
}